/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import { scrollToTop } from "../constent/helper";

export const Footer = () => {
  return (
    <div className="footer-v2__upper">
      <div className="footer-v2__social-links">
        <a className="footer-v2__social-link" href="#">
          <div className="bg-[#0EA5A4] rounded-full p-[6px]">
            <FaFacebookF className="text-black w-4 h-4" />
          </div>
        </a>
        <a className="footer-v2__social-link" href="#">
          <div className="bg-[#0EA5A4] rounded-full p-[6px]">
            <FaTwitter className="text-black w-4 h-4" />
          </div>
        </a>
        <a className="footer-v2__social-link" href="#">
          <div className="bg-[#0EA5A4] rounded-full p-[6px]">
            <FaLinkedinIn className="text-black w-4 h-4" />
          </div>
        </a>
        {/* <a className='footer-v2__social-link' href='#'>
        <img src ={Pintrest} alt='facebook' width='30px' />
        </a> */}
      </div>
      <ul className="footer-v2__links pt-2.5 pl-0 mb-0">
        <li className="footer-v2__link">
          <Link
            to="/aboutus"
            onClick={() => scrollToTop()}
            className="!text-[#BFC1C4] px-3 border-r border-[#BFC1C4]"
          >
            About us
          </Link>
        </li>
        <li className="footer-v2__link">
          <Link
            to="/blogs"
            onClick={()=>scrollToTop()}
            className="!text-[#BFC1C4] px-3 border-r border-[#BFC1C4]"
          >
            Blogs
          </Link>
        </li>
        <li className="footer-v2__link">
          <Link
            to="/casesfeeds"
            onClick={() => scrollToTop()}
            className="!text-[#BFC1C4] px-3 border-r border-[#BFC1C4]"
          >
            Projects
          </Link>
        </li>
        <li className="footer-v2__link">
          <Link
            onClick={() => scrollToTop()}
            to="/donation"
            className="!text-[#BFC1C4] px-3 "
          >
            Donation
          </Link>
        </li>
      </ul>
    </div>
  );
};
